// extracted by mini-css-extract-plugin
module.exports = {"container":"iv","list":"jv"};